/** Project home, details and build — plus the `projects` role-management namespace. */

export default {
	project: {
		overview: "Übersicht",
		settings: "Einstellungen",
		build: {
			passing: "Build erfolgreich",
			failed: "Build fehlgeschlagen",
			idle: "Noch kein Build",
			idleNote: "Bauen Sie das Projekt, um zu prüfen, ob es kompiliert.",
			startedNote: "Projektgraph wird kompiliert.",
			passingNote: "{files} Dateien in {seconds}s.",
			typeWarnings: "Gebaut mit Typwarnungen",
		},
		typecheck: {
			section: "Build",
			title: "Build-Typprüfung",
			hint: "Beim Bündeln werden Typen nie geprüft. Dieser Schritt tut es — und welche Folgen ein Typfehler für den Build hat, legen Sie fest.",
			check: "Typen jetzt prüfen",
			clean: "Keine Typfehler.",
			resultTitle: "Typfehler",
			saved: "Einstellung zur Typprüfung gespeichert.",
			severityLabel: {
				error: "Build fehlschlagen lassen",
				warn: "Warnen, aber trotzdem bauen",
				off: "Prüfung überspringen",
			},
			severityHelp: {
				error: "Solange ein Typfehler besteht, wird nichts gebündelt. Die strengste Einstellung — richtig für ein Projekt, das Sie sauber halten.",
				warn: "Die Voreinstellung. Das Bündel wird erzeugt und die Fehler werden dazu gemeldet — so kann eine vergessene, veraltete Referenz das Projekt nicht an der Auslieferung hindern.",
				off: "Keine Typprüfung. Der Build geht schneller, eine kaputte Referenz fällt dafür erst zur Laufzeit auf.",
			},
		},
		coverage: {
			title: "Übersetzungsgrad",
			summary: "{languages} Sprachen · {complete} vollständig übersetzt",
			more: "{count} weitere Sprache in den Einstellungen | {count} weitere Sprachen in den Einstellungen",
			manage: "Sprachen verwalten",
			empty: "Noch keine Terminologie.",
		},
		team: {
			title: "Team",
			/** Under the first few on the team, how many more there are. */
			more: "und {n} weitere | und {n} weitere",
		},
		listTitle: "Projekte",
		empty: {
			title: "Noch keine Projekte",
			hint: "Erstellen Sie Ihr erstes Projekt.",
		},
		noResults: "Keine Projekte entsprechen Ihrer Suche.",
		deleteConfirm: "Projekt „{name}“ löschen?",
		resultCount: "{n} von {total} Projekten",
		filesMissing: "Dateien fehlen",
		filesMissingNote:
			"Die Dateien dieses Projekts fehlen auf dem Server, deshalb lässt es sich nicht öffnen. Eine Serveradministration kann es in der Wartung des Kontrollzentrums entfernen.",
		meta: {
			version: "Version",
			created: "Erstellt",
			updated: "Aktualisiert",
		},
		sections: {
			members: "Mitglieder",
		},
		name: "Projektname",
		create: "Neues Projekt",
		copyId: "Projekt-ID kopieren",
		search: "Projekte suchen…",
		details: "Projektdetails",
		languages: {
			title: "Unterstützte Sprachen",
			hint: "Englisch ist die Quellsprache und kann nicht entfernt werden.",
			add: "Sprache hinzufügen",
			addHint: "Nach einer Sprache suchen.",
			addEmpty: "Keine Sprachen mehr verfügbar.",
			addDone: "Fertig",
			remove: "{name} entfernen",
			added: "{name} hinzugefügt.",
			removed: "{name} entfernt.",
		},
	},
	build: {
		buildWip: "WIP bauen",
		noProcess:
			"Legen Sie zuerst einen Prozess an — ein Projekt ohne Prozess lässt sich nicht bauen.",
		building: "Wird gebaut…",
		success: "Gebaut in {ms}ms · {files} Dateien",
		failed: "Build fehlgeschlagen",
		typeWarnings: "Typwarnungen",
		buildFailed: "Build mit Fehlern abgeschlossen.",
		autoScheduled: "Auto-Build geplant…",
		viewError: "Fehlerdetails anzeigen",
		viewTypeWarnings: "Typwarnungen anzeigen",
		errorDialogTitle: "Build-Fehler",
		typeWarningsDialogTitle: "Typwarnungen",
		copyError: "Fehler kopieren",
		copied: "Kopiert",
	},
};
